import { AgendaItem } from '../schema/AgendaItem';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    getCalendarEventItemSubjectText,
    getCalendarEventItemLocationText,
    getCalendarEventItemAriaLabel,
    getCalendarEventItemTitle,
} from 'owa-calendar-event-attributes';

export function getAgendaItemFromCalendarItem(calendarEvent: CalendarEvent): AgendaItem {
    return {
        __type: 'AgendaItem',
        id: calendarEvent.ItemId,
        subject: getCalendarEventItemSubjectText(calendarEvent),
        startTime: calendarEvent.Start,
        endTime: calendarEvent.End,
        location: getCalendarEventItemLocationText(calendarEvent),
        organizerName: calendarEvent.Organizer && calendarEvent.Organizer.Mailbox.Name,
        organizerEmail: calendarEvent.Organizer && calendarEvent.Organizer.Mailbox.EmailAddress,
        isAllDay: calendarEvent.IsAllDayEvent,
        isCancelled: calendarEvent.IsCancelled || calendarEvent.ResponseType === 'Decline',
        freeBusyType: calendarEvent.FreeBusyType,
        parentFolderId: calendarEvent.ParentFolderId,
        categories: calendarEvent.Categories,
        isRecurring: calendarEvent.CalendarItemType === 'Occurrence',
        hasAttachments: calendarEvent.HasAttachments,
        isRecurringException: calendarEvent.CalendarItemType === 'Exception',
        isPrivate: calendarEvent.Sensitivity === 'Private',
        isMeeting: isEventAMeeting(calendarEvent),
        isLocalLie: isCalendarEventLocalLie(calendarEvent),
        joinUrl: calendarEvent.OnlineMeetingJoinUrl,
        provider: calendarEvent.OnlineMeetingProvider,
        charmId: calendarEvent.CharmId,
        ariaLabel: getCalendarEventItemAriaLabel(calendarEvent),
        title: getCalendarEventItemTitle(calendarEvent),
        isOrganizer: calendarEvent.IsOrganizer,
    };
}
